module.exports = __webpack_public_path__ + "static/img/abvlr-BFO0Rfku.6aa0f29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/abvlr-BFO0Rfku.png
// module id = lUIa
// module chunks = 16